import { intersection } from 'lodash';
import cookie from './cookie';

class Auth {
  checkAuth(auths) {
    const cookie_a = cookie.get('a');
    if (!cookie_a) window.location.replace('/login');
    const auth_list = cookie_a.split(',');
    if (!auths) return true;
    if (auth_list.indexOf('S') > -1) return true;
    if (!auth_list || !auth_list.length) return false;
    // const val_arr = value.split(',');
    const val_arr = auths;
    console.log("checkAuth", auths, auth_list, !!intersection(auth_list, val_arr).length);
    return !!intersection(auth_list, val_arr).length;
  }
}

const auth = new Auth();
export default auth;